jQuery(document).ready(function ($) {
    $('[data-fancybox="gallery"]').fancybox({
        buttons: ["zoom", "slideShow", "thumbs", "close"],
        loop: true,
        animationEffect: "fade",
    });
});
